//时长转时分秒
export function formatSeconds(seconds) {
    var day = parseInt(Math.floor(seconds / (60 * 60 * 24)));
    var hour = day > 0 ? parseInt(Math.floor((seconds - day * (60 * 60 * 24)) / (60 * 60))) : parseInt(Math.floor(seconds / (60 * 60)));
    var minute = hour > 0 ? parseInt(Math.floor(seconds - day * (60 * 60 * 24) - hour * (60 * 60)) / 60) : parseInt(seconds / 60);
    var time = "";
    if (day > 0) time += day + "天";
    if (hour > 0) time += hour + "小时";
    if (minute > 0) time += minute + "分钟";
    if (time == "") time = seconds + "秒";
    return time;
}

//对比文本相似度0-1
export function similarity(str1, str2) {
    try {
        const len1 = str1.length;
        const len2 = str2.length;
        const matrix = [];
        let i;
        let j;

        for (i = 0; i <= len1; i++) {
            matrix[i] = [i];
        }

        for (j = 0; j <= len2; j++) {
            matrix[0][j] = j;
        }

        for (i = 1; i <= len1; i++) {
            for (j = 1; j <= len2; j++) {
                if (str1[i - 1] === str2[j - 1]) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                } else {
                    matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
                        Math.min(matrix[i][j - 1] + 1, // insertion
                            matrix[i - 1][j] + 1)); // deletion
                }
            }
        }

        return 1 - matrix[len1][len2] / Math.max(len1, len2);


    } catch (error) {
        console.log("similarity:" + error.stack)
    }
}